import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Paper, Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useEditor } from "@craftjs/core";
import Scrollbars from "react-custom-scrollbars-2";
import EmptyState from "@/components/EmptyState";
import StylesEditor from "../Settings/StylesEditor";
import "./Settings.scss";

enum SettingsViews {
  SETTINGS = "SETTINGS",
  ADVANCED = "ADVANCED",
}

const Settings = () => {
  const [selectedView, setSelectedView] = useState<SettingsViews>(SettingsViews.SETTINGS);
  const { templateId, websiteId } = useParams();

  const isTemplateEditor = templateId;

  const { selected, actions } = useEditor((state, query) => {
    const [currentNodeId] = state.events.selected;

    let selected;

    if (currentNodeId) {
      selected = {
        id: currentNodeId,
        name: state.nodes[currentNodeId].data.name,
        settings: state.nodes[currentNodeId].related && state.nodes[currentNodeId].related.settings,
        isDeletable: query.node(currentNodeId).isDeletable(),
      };
    }

    return {
      selected,
    };
  });

  return (
    <div className="editor__settings">
      <Scrollbars autoHide style={{ flex: 1 }}>
        <Stack spacing={2}>
          {isTemplateEditor || websiteId ? (
            <Paper>
              <ToggleButtonGroup exclusive fullWidth size="small" color="primary" value={selectedView} onChange={(_, value) => setSelectedView(value)}>
                <ToggleButton value={SettingsViews.SETTINGS}>Configuraciones</ToggleButton>
                <ToggleButton value={SettingsViews.ADVANCED}>Avanzados</ToggleButton>
              </ToggleButtonGroup>
            </Paper>
          ) : null}

          {selectedView === SettingsViews.SETTINGS ? (
            <Stack spacing={2}>
              {!selected?.settings ? (
                <Paper sx={{ padding: 2 }}>
                  <EmptyState title="Elija un bloque" description="Para editar un bloque, primero seleccionelo" />
                </Paper>
              ) : null}
              {selected?.settings && React.createElement(selected.settings)}
              {selected?.isDeletable ? (
                <Button
                  fullWidth
                  size="small"
                  variant="contained"
                  color="error"
                  onClick={() => {
                    actions.delete(selected.id);
                  }}
                >
                  Delete
                </Button>
              ) : null}
            </Stack>
          ) : (
            <StylesEditor />
          )}
        </Stack>
      </Scrollbars>
    </div>
  );
};

export default Settings;
